import { AbsenceTypeId } from "~/modules/absence/api/absence/absenceTypes.ts";

export const LONG_TERM_ABSENCE_TYPE_IDS = [AbsenceTypeId.MaternityLeave, AbsenceTypeId.ParentalLeave, AbsenceTypeId.Sabbatical];